<template>
  <div>
    <div class="layout-container grid h-screen w-screen">
      <SidebarProvider>
        <Sidebar />
        <main class="w-full overflow-y-scroll">
          <HeaderToolbar>
            <SidebarTrigger />
          </HeaderToolbar>
          <div class="grid grid-cols-8">
            <div class="col-span-8 flex flex-col">
              <div class="flex-grow p-8">
                <slot></slot>
              </div>
            </div>
          </div>
        </main>
      </SidebarProvider>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import Sidebar from './Sidebar/index.vue';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import HeaderToolbar from '../HeaderToolbar.vue';

onMounted(() => {
  window.document.body.classList.add('lg:overflow-hidden');
});
</script>

<style>
.layout-container {
  grid-template-rows: 70px calc(100vh - 70px);
}
</style>
